import { useContext, useEffect, useState } from 'react';
import { distinctUntilChanged } from 'rxjs';

import { RxFormContext } from '../Context';
import { createDebug } from '../utils/debug';

const debug = createDebug('useSubmitCount');

export function useSubmitCount() {
    const ctx = useContext(RxFormContext);
    const [state, setState] = useState(0);
    useEffect(() => {
        debug('++mount');
        const sub = ctx.getSubmitCountStream().pipe(distinctUntilChanged()).subscribe(setState);
        return () => {
            debug('--unmount');
            sub.unsubscribe();
        };
    }, [ctx]);
    return state;
}
